<script>
	export let title;
	export let x;
	export let y;
</script>

<div
	style="
		top: {y + 10}px;
		left: {x + 10}px;"
>
	{@html title}
</div>

<style>
	div {
		border-radius: 10px;
		padding: 12px 16px;
		position: absolute;
		font-size: 0.8rem;
		line-height: 1.45;
		letter-spacing: -0.01em;
		font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", Arial, sans-serif;
		color: #1d1d1f;
		background: rgba(255, 255, 255, 0.88);
		backdrop-filter: blur(20px) saturate(180%);
		-webkit-backdrop-filter: blur(20px) saturate(180%);
		border: 1px solid rgba(0, 0, 0, 0.08);
		box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12), 0 0 1px rgba(0, 0, 0, 0.06);
		z-index: 1000;
		max-width: 420px;
		pointer-events: none;
	}
</style>
